import { render } from "./WalletConnectPage.vue?vue&type=template&id=8885a0b6&ts=true"
import script from "./WalletConnectPage.vue?vue&type=script&lang=ts"
export * from "./WalletConnectPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__